import { Outlet } from 'react-router-dom';
import { PageLoadingSpinner } from 'shared/components/LoadingSpinner/PageLoadingSpinner';
import { useRemoteDictionariesQuery } from 'shared/hooks/api/remoteDictionaries/remoteDictionaries.generated';
import { useExpertDataRealtimerEvents } from 'shared/hooks/useExpertDataRealtimerEvents';

export const DataFetchContainer = () => {
  const { loading } = useRemoteDictionariesQuery();

  useExpertDataRealtimerEvents();

  if (loading) {
    return <PageLoadingSpinner />;
  }

  return <Outlet />;
};
